import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { inject } from '@vercel/analytics'

// Vercel Analyticsを初期化
inject()

createApp(App)
    .use(store)
    .use(router)
    .mount('#app')